import React from 'react';
import './Publications.css';

const Publications = () => {
    const featuredSeries = [
        {
            name: "Programming Series",
            description:
                "Books on Python, Java, problem-solving, coding foundations, and technical interview preparation.",
            image:
                "https://in.bpbonline.com/cdn/shop/files/2539_Epub.jpg?v=1762253596&width=600",
            previews: [
                "https://in.bpbonline.com/cdn/shop/files/2539_Epub.jpg?v=1762253596&width=200",
                "https://m.media-amazon.com/images/I/71wi3aHsnVL._SL1499_.jpg",
                "https://m.media-amazon.com/images/I/61IvdkXSPnL._SY522_.jpg"
            ],
            url: "https://www.amazon.in/s?k=ashutosh+shashi+programming"
        },
        {
            name: "Cloud Architecture Series",
            description:
                "Practical guides for scalable systems, cloud modernization, and real-world architecture patterns.",
            image:
                "https://m.media-amazon.com/images/I/61Egj3ASKSL._SY522_.jpg",
            previews: [
                "https://m.media-amazon.com/images/I/61Egj3ASKSL._SY522_.jpg",
                "https://m.media-amazon.com/images/I/61sRMtTQTML._SY522_.jpg",
                "https://m.media-amazon.com/images/I/71aTxvlgrBL._SL1500_.jpg"
            ],
            url: "https://www.amazon.in/s?k=ashutosh+shashi+cloud"
        }
    ];

    const books = [
        {
            title: "Python Interview Preparation",
            topic: "Python, problem solving, and interviews",
            url: "https://in.bpbonline.com/products/python-interview-preparation",
            cover:
                "https://in.bpbonline.com/cdn/shop/files/2539_Epub.jpg?v=1762253596&width=600",
            coverAlt: "Python Interview Preparation book by Ashutosh Shashi"
        },
        {
            title: "Cloud Architecture Guide",
            topic: "Cloud architecture and platform design",
            url: "https://a.co/d/fK81ofF",
            cover: "https://m.media-amazon.com/images/I/61Egj3ASKSL._SY522_.jpg",
            coverAlt: "Designing Applications for Google Cloud Platform book by Ashutosh Shashi"
        },
        {
            title: "Programming Foundations",
            topic: "Coding foundations and software concepts",
            url: "https://a.co/d/gjULg83",
            cover: "https://m.media-amazon.com/images/I/61IvdkXSPnL._SY522_.jpg"
        },
        {
            title: "Cloud Modernization Patterns",
            topic: "Modernization and architecture practices",
            url: "https://a.co/d/8LvnHzB",
            cover: "https://m.media-amazon.com/images/I/61sRMtTQTML._SY522_.jpg"
        },
        {
            title: "Technology Leadership Reference",
            topic: "Engineering practice and technical growth",
            url: "https://a.co/d/4oFAPBD",
            cover: "https://m.media-amazon.com/images/I/61um8UYFsWL._SL1499_.jpg"
        },
        {
            title: "Python Programming Guide",
            topic: "Python programming and practical learning",
            url: "https://a.co/d/b3xfWOC",
            cover: "https://m.media-amazon.com/images/I/71wi3aHsnVL._SL1499_.jpg"
        },
        {
            title: "Architecture Patterns Guide",
            topic: "Software architecture and system design",
            url: "https://a.co/d/9cQ1nnY",
            cover: "https://m.media-amazon.com/images/I/71aTxvlgrBL._SL1500_.jpg"
        }
    ];

    /** 3D Tilt Animation **/
    const handleMouseMove = (e) => {
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

        const card = e.currentTarget;
        const rect = card.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;

        const rotateX = ((y - rect.height / 2) / 20).toFixed(2);
        const rotateY = ((rect.width / 2 - x) / 20).toFixed(2);

        card.style.transform = `
      perspective(800px)
      rotateX(${rotateX}deg)
      rotateY(${rotateY}deg)
      scale(1.05)
    `;
    };

    const resetTilt = (e) => {
        const card = e.currentTarget;
        card.style.transform =
            "perspective(800px) rotateX(0deg) rotateY(0deg) scale(1)";
    };

    return (
        <section id="publications" className="publications">
            <div className="publications-inner">
                <header className="section-header publications-header">
                    <div className="section-kicker">Publications</div>
                    <h2>Seven Technology Books for Practitioners</h2>
                    <p>
                        Books that translate complex engineering topics into practical
                        learning paths for developers, architects, and technology leaders.
                    </p>
                </header>

                {/* FEATURED SERIES */}
                <div className="featured-series-row">
                    {featuredSeries.map((series) => (
                        <a
                            key={series.name}
                            href={series.url}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="featured-series-card"
                        >
                            <div className="series-main-cover">
                                <img src={series.image} alt={`${series.name} featured cover`} />
                            </div>

                            <div className="series-info">
                                <h3>{series.name}</h3>
                                <p>{series.description}</p>

                                <div className="series-previews">
                                    {series.previews.map((p, idx) => (
                                        <img
                                            key={idx}
                                            src={p}
                                            alt={`${series.name} book preview ${idx + 1}`}
                                            className="series-preview-thumb"
                                        />
                                    ))}
                                </div>

                                <span className="series-link">Explore series</span>
                            </div>
                        </a>
                    ))}
                </div>

                {/* BOOK GRID */}
                <div className="publications-grid">
                    {books.map((book, index) => (
                        <div
                            key={index}
                            className="publication-card"
                            onMouseMove={handleMouseMove}
                            onMouseLeave={resetTilt}
                        >
                            <a
                                href={book.url}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="image-link"
                                aria-label={`View ${book.title}`}
                            >
                                <img
                                    src={book.cover}
                                    alt={book.coverAlt || `${book.title} book by Ashutosh Shashi`}
                                    className="book-cover"
                                />
                            </a>

                            <div className="publication-copy">
                                <h3>{book.title}</h3>
                                <p>{book.topic}</p>
                            </div>

                            <a
                                href={book.url}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="view-book-link"
                            >
                                View book
                            </a>
                        </div>
                    ))}
                </div>

            </div>
        </section>
    );
};

export default Publications;
